import styled from 'styled-components';

const SearchDescription = styled.div`
  margin: 16px -20px 0 36px;
  height: 112px;
  overflow: auto;
  padding-right: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid black;
  font-size: 15px;

  a {
    text-decoration: underline;
    font-size: 15px;
  }
`;

export default SearchDescription;
